import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import StoreSearch from './StoreSearch'
import { selectIsTablet } from '../../../layout/state/selector'


const mapStateToProps = state => {
    return {
        tableData: selector.tableSelectorStore(state),
        isTablet: selectIsTablet(state),
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryStore,
    initialTableSettings: action.initialTableSettings,
    toggleColumnVisibility: action.toggleColumnVisibility,
    changeFilter: action.changeFilterStore,
    toggleSort: action.toggleSortStore,
    toggleMultiSort: action.toggleMultiSortStore,
    gotoPage: action.gotoPageStore,
    navigateToStore: (storeId) => {
        return push('/store/edit/' + storeId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(StoreSearch)



// WEBPACK FOOTER //
// ./src/modules/store/component/search/StoreSearchContainer.js